import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ManageQuestionnaires.css";
import publicAxios from "../../utils/axios/publicAxios";
import moment from "moment";

const ManageQuestionnaires = () => {
  const [questionnaires, setQuestionnaires] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  // Fetch all questionnaires
  const fetchQuestionnaires = async (pageNumber = 1, searchTerm = "") => {
    setLoading(true);
    try {
      const endpoint = searchTerm
        ? `/public/manage-search-questionnaires?query=${encodeURIComponent(searchTerm)}&page=${pageNumber}`
        : `/public/manage-questionnaires?page=${pageNumber}`;
      const response = await publicAxios.get(endpoint);

      if (response.data.success) {
        setQuestionnaires(response.data.questionnaires);
        setTotalPages(response.data.totalPages);
        setPage(response.data.currentPage);
        setMessage("");
      } else {
        setMessage("⚠️ Unable to load questionnaires.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setMessage("❌ Error fetching questionnaires.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch on mount and when page changes
  useEffect(() => {
    fetchQuestionnaires(page, search);
  }, [page]);

  // Handle search
  const handleSearch = (e) => {
    e.preventDefault();
    fetchQuestionnaires(1, search);
  };

  // Navigate to individual questionnaire page
  const handleViewQuestionnaire = (slugOrId) => {
    navigate(`/questionnaire/${slugOrId}`);
  };

  return (
    <div className="manage-questionnaires-container">
      <div className="manage-questionnaires-header">
        <h1>All Questionnaires</h1>
        <p className="subtitle">
          Browse through all available questionnaires. Click one to view details.
        </p>
      </div>

      {/* Search bar */}
      <form className="search-bar" onSubmit={handleSearch}>
        <input
          type="text"
          placeholder="Search questionnaires..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button type="submit">Search</button>
      </form>

      {loading ? (
        <p className="loading-text">Loading questionnaires...</p>
      ) : questionnaires.length === 0 ? (
        <p className="empty-text">No questionnaires found.</p>
      ) : (
        <div className="questionnaire-grid">
          {questionnaires.map((q) => (
            <div
              key={q._id}
              className="questionnaire-card"
              onClick={() => handleViewQuestionnaire(q.slug || q._id)}
            >
              <h2>{q.title}</h2>
              <p className="description">
                {q.description?.slice(0, 120) || "No description"}...
              </p>
              <div className="meta">
                <span>
                  👤{" "}
                  {q.createdBy
                    ? `${q.createdBy.firstname} ${q.createdBy.lastname}`
                    : "Unknown"}
                </span>
                <span>📅 {moment(q.createdAt).format("MMM DD, YYYY")}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            ◀ Prev
          </button>
          <span>
            Page {page} of {totalPages}
          </span>
          <button
            disabled={page === totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next ▶
          </button>
        </div>
      )}

      {message && <p className="status-message">{message}</p>}
    </div>
  );
};

export default ManageQuestionnaires;